import { render } from "./Home.vue?vue&type=template&id=4e115f52&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=4e115f52&lang=css"
import "./Home.vue?vue&type=style&index=1&id=4e115f52&scoped=true&lang=css"

import exportComponent from "/Users/macbook/Desktop/SILA/Web/phone/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e115f52"]])

export default __exports__